<template>
    <div class="container-fluid" >
         <div class="row justify-content-between my-3">
            <div class="col"> <h3>Асуулга</h3></div>
            <div class="col-auto">
                <button type="button" class="btn btn-success" data-toggle="modal" data-target="#qaModal">
                    Асуулга нэмэх
                </button>
            </div>
        
        </div>
       
        
      <div v-if="asuulga!=null && asuulga.length>0">
        
        <div  class="card shadow mb-4" v-for="(q, index) in asuulga" v-bind:key="q.id">
            <div class="card-header py-3">
                <div class="row justify-content-between">
                    <div class="col col-10">
                        <h3 class="m-0 font-weight-bold text-primary">{{index+1}}.  {{q.name}}</h3>
                    </div>
                    <div class="col col-md-auto">
                        <i class="fas fa-edit" @click="_goQuestions(q.id)" ></i>
                    </div>
                     <div class="col col-md-auto">
                        <i class="fas fa-trash text-danger" @click="_deleteQA(q)" ></i>
                    </div>
                </div>
            
            <p>{{q.description}}</p>
            <p>Асуулгын код: {{q.postId}}</p>
            

            
            </div>
        </div>
      </div>
      <div v-else class="alert alert-info">Та одоогоор ямар нэгэн асуулга оруулаагүй байна.</div>
      <!-- Modal -->
      <div class="modal fade" id="qaModal" tabindex="-1" role="dialog" aria-labelledby="qaModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="qaModalLabel">Асуулга нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="form-group">
                  <input v-model.trim="object.name" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Асуулгын нэр">
                </div>
                <div class="form-group">
                  <textarea rows="10" v-model.trim="object.description" class="form-control" id="exampleInputPassword" placeholder="Асуулгын дэлгэрэнгүй"/>
                </div>

                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button @click="saveQa" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')

    export default {
        data() {
            return {
                asuulga:[],
                object:{
                    name:'',
                    description:'',

                }

            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },


        methods: {

            _getQA(){
                this.asuulga=[];

                fb.db.collection("asuulga").where("userId", "==", this.currentUser.uid).orderBy("createdAt").onSnapshot(querySnapshot=> {
                    this.asuulga=[];
                    querySnapshot.forEach(doc=> {
                        let object=doc.data()
                        object.id = doc.id
                        this.asuulga.push(object);
                    });
                });


            
            },
            _goQuestions(postId){
                this.$router.push({ name: 'Questions', params: { qaId: postId} })
            },
            _deleteQA(qa){
                var result = confirm("Та "+qa.name+" асуулгыг устгах уу?");
                if (result) {
                    fb.db.collection("asuulga").doc(qa.id).delete()
                }
            },
            _goPublic(postId){
                this.$router.push({ name: 'QuestionPublic', params: { postId: postId} })
            },
            saveQa(){
                if(this.object!=null && this.object!=null && this.object.name!='' && this.object.description!=''){
              
                    this.object.createdAt=new Date()
                    this.object.userId=this.$store.getters.currentUser.uid;
                    this.object.user=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                    this.postId=new Date().getTime().toString()
                    fb.db.collection("asuulga").doc().set(this.object)
                    this.object={
                        'name':null,
                        'description':null
                    }

                }
            }
  
        },
        created() {
            var _this=this;

            this._getQA();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
